import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-events",
  templateUrl: "./events.component.html",
  styleUrls: ["./events.component.scss"],
})
export class EventsComponent implements OnInit {

  public formasDeIngresso = [
    {
      titulo: "Simplificado",
      descricao: "Entre só com uma carta de apresentação.",
      link: "https://matricula.virtualfacint.com.br",
    },
    {
      titulo: "Vestibular",
      descricao: "Faça a prova online ou presencial.",
      link: "https://matricula.virtualfacint.com.br",
    },
    {
      titulo: "Enem",
      descricao: "Tenha descontos com a sua nota do Enem.",
      link: "https://matricula.virtualfacint.com.br",
    },
    {
      titulo: "2ª Graduação",
      descricao: "Aproveite suas disciplinas.",
      link: "https://matricula.virtualfacint.com.br",
    },
    {
      titulo: "Transferência",
      descricao: "Troque para a Facint sem custo nenhum.",
      link: "https://matricula.virtualfacint.com.br",
    },
    {
      titulo: "Reabertura",
      descricao: "Volte a estudar agora mesmo.",
      link: "https://matricula.virtualfacint.com.br",
    },
  ];

  constructor() {}

  ngOnInit(): void {}
}
